import React from 'react';
import ReactDOM from 'react-dom/client';
import DoctorFinder from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DoctorFinder />
  </React.StrictMode>
);
